import { createStoreWithSubscribe } from '@frontend/store';
import { WeaveLocation, WeaveLocationGroup } from './types';

interface AllAccessScopeStore {
  accessibleLocationIds: string[];
  accessibleLocationMap: Record<string, WeaveLocation>;
  setAccessibleLocationMap: (map: Record<string, WeaveLocation>) => void;
  accessibleGroupMap: Record<string, WeaveLocationGroup>;
  setAccessibleGroupMap: (map: Record<string, WeaveLocationGroup>) => void;
}

export const useAllAccessScopeStore = createStoreWithSubscribe<AllAccessScopeStore>(
  (set) => ({
    accessibleLocationIds: [],

    accessibleLocationMap: {},
    setAccessibleLocationMap: (map) => {
      set(
        {
          accessibleLocationIds: Object.keys(map),
          accessibleLocationMap: map,
        },
        false,
        { type: 'setAccessibleLocationMap' }
      );
    },
    accessibleGroupMap: {},
    setAccessibleGroupMap: (map) => {
      set({ accessibleGroupMap: map }, false, { type: 'setAccessibleGroupMap' });
    },
  }),
  { name: 'AllAccessScopeStore', trace: true }
);
